module.exports = __webpack_public_path__ + "img/20190802132247QQ截图20190802015633.4cff21cc.png";